import { forwardRef, lazy, Suspense } from 'react'

import { cn } from '@/components/new/lib/utils'
import { Skeleton } from '@/components/new/ui/skeleton'

import { RichTextEditorHandle, RichTextEditorProps } from './types'

// The editor brings over a megabyte of code, which only pages that show one should load
const RichTextEditorContent = lazy(async () => ({
    default: (await import('./RichTextEditorContent')).RichTextEditorContent,
}))

export const RichTextEditor = forwardRef<RichTextEditorHandle, RichTextEditorProps>((props, ref) => {
    const { className, mode = 'rich' } = props

    return (
        <Suspense
            fallback={<Skeleton className={cn(mode === 'rich' || mode === 'plain' ? 'h-32' : 'h-9', className)} />}
        >
            <RichTextEditorContent ref={ref} {...props} />
        </Suspense>
    )
})
